var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.871,
    height: 16.87,
    viewBox: "0 0 16.871 16.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M8.7,7.107A1.127,1.127,0,1,0,7.106,8.7l6.511,6.51-6.511,6.51A1.127,1.127,0,1,0,8.7,23.315l6.511-6.51,6.511,6.511a1.127,1.127,0,1,0,1.594-1.594l-6.511-6.51L23.316,8.7a1.127,1.127,0,1,0-1.594-1.594l-6.51,6.511L8.7,7.106Z",
    transform: "translate(-6.776 -6.777)",
    fill: "#c0321f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRedIcon);
export default __webpack_public_path__ + "static/media/close-red-icon.0c6ee9b647f845ab2bd765b86685a55e.svg";
export { ForwardRef as ReactComponent };